import type { Skeleton } from './core';

export function buildShortestBonePathRefs(
  skeleton: Skeleton | null,
  startBoneRef: string,
  endBoneRef: string,
): string[] | null {
  if (!skeleton) return null;

  const startBoneIndex = skeleton.resolveBoneRef(startBoneRef, {
    namespace: 'internal',
  });
  const endBoneIndex = skeleton.resolveBoneRef(endBoneRef, {
    namespace: 'internal',
  });
  if (startBoneIndex === null || endBoneIndex === null) return null;

  const startLineage = [startBoneIndex, ...skeleton.ancestors(startBoneIndex)];
  const startDepthMap = new Map<number, number>();
  for (let i = 0; i < startLineage.length; i += 1) {
    startDepthMap.set(startLineage[i], i);
  }

  const endLineage = [endBoneIndex, ...skeleton.ancestors(endBoneIndex)];
  let lcaIndex: number | null = null;
  let endDepthToLca = -1;
  for (let i = 0; i < endLineage.length; i += 1) {
    const idx = endLineage[i];
    if (!startDepthMap.has(idx)) continue;
    lcaIndex = idx;
    endDepthToLca = i;
    break;
  }
  if (lcaIndex === null) return null;

  const startDepthToLca = startDepthMap.get(lcaIndex);
  if (startDepthToLca === undefined) return null;

  const pathFromStartToLca = startLineage.slice(0, startDepthToLca + 1);
  const pathFromEndToLca = endLineage.slice(0, endDepthToLca);
  const fullPathIndices = [
    ...pathFromStartToLca,
    ...pathFromEndToLca.reverse(),
  ];

  return fullPathIndices.map((idx) => skeleton.refForBoneIndex(idx));
}
